"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsUtils = void 0;
var __1 = require("..");
/**
 * @author arnozhang
 * @date 2019/06/25
 */
var TAG = 'JsUtils';
var JsUtils = /** @class */ (function () {
    function JsUtils() {
    }
    JsUtils.isEmpty = function (value) {
        return value == null || value.length <= 0;
    };
    JsUtils.isNotEmpty = function (value) {
        return !JsUtils.isEmpty(value);
    };
    JsUtils.isString = function (value) {
        return typeof value === 'string';
    };
    JsUtils.isNumber = function (value) {
        return typeof value === 'number';
    };
    JsUtils.isBoolean = function (value) {
        return typeof value === 'boolean';
    };
    JsUtils.isObject = function (value) {
        return typeof value === 'object' && !JsUtils.isArray(value);
    };
    JsUtils.isArray = function (value) {
        return Array.isArray(value);
    };
    JsUtils.isObjectOrArray = function (value) {
        return typeof value === 'object';
    };
    JsUtils.isFunction = function (value) {
        return typeof value === 'function';
    };
    JsUtils.parseIntSafe = function (content, defInt) {
        if (content == null) {
            return defInt;
        }
        if (JsUtils.isNumber(content)) {
            return parseInt("" + content);
        }
        else if (!JsUtils.isString(content)) {
            __1.Logger.e(TAG, "parseInt '" + content + "' is not string. type = " + typeof content);
            return defInt;
        }
        try {
            return parseInt(content);
        }
        catch (e) {
            __1.Logger.e(TAG, "parseInt '" + content + "' error: " + e);
        }
        return defInt;
    };
    JsUtils.parseFloatSafe = function (content, defFloat) {
        if (content == null) {
            return defFloat;
        }
        if (JsUtils.isNumber(content)) {
            return content;
        }
        else if (!JsUtils.isString(content)) {
            __1.Logger.e(TAG, "parseFloat '" + content + "' is not string. type = " + typeof content);
            return defFloat;
        }
        try {
            return parseFloat(content);
        }
        catch (e) {
            __1.Logger.e(TAG, "parseFloat '" + content + "' error: " + e);
        }
        return defFloat;
    };
    return JsUtils;
}());
exports.JsUtils = JsUtils;
